<script setup lang="ts">
const { t } = useI18n();

useHead({
  titleTemplate: () => t("intentPages.viberChatbotApi.title") || t("intentPages.viberChatbotApi.heroTitle"),
  meta: [
    { name: "description", content: () => t("intentPages.viberChatbotApi.subtitle") || t("intentPages.viberChatbotApi.heroSubtitle") },
    { property: "og:title", content: () => t("intentPages.viberChatbotApi.title") || t("intentPages.viberChatbotApi.heroTitle") },
    { property: "og:description", content: () => t("intentPages.viberChatbotApi.subtitle") || t("intentPages.viberChatbotApi.heroSubtitle") },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary_large_image" }
  ]
});

const faqItems = ref([
  {
    question: t('intentPages.viberChatbotApi.faq.q1'),
    answer: t('intentPages.viberChatbotApi.faq.a1'),
    isOpen: false
  },
  {
    question: t('intentPages.viberChatbotApi.faq.q2'),
    answer: t('intentPages.viberChatbotApi.faq.a2'),
    isOpen: false
  },
  {
    question: t('intentPages.viberChatbotApi.faq.q3'),
    answer: t('intentPages.viberChatbotApi.faq.a3'),
    isOpen: false
  }
]);

onMounted(() => {
  document.querySelector("body")?.scrollIntoView();
});
</script>

<template>
  <div class="provider-intent-page">
    
    <!-- Hero Banner -->
    <div class="main-banner bg-gradient-to-br from-slate-50 to-slate-200 pt-[120px] pb-20 px-4">
      <div class="container mx-auto max-w-5xl text-center">
        <div class="flex justify-center mb-8">
           <a href="https://www.forbusiness.viber.com/ua/messaging-partners/smsbat/" target="_blank" rel="noopener noreferrer" class="transition-transform hover:-translate-y-1 block inline-block">
             <NuxtImg src="/images/partners/viber-silver-partner.png" width="130" height="188" format="webp" loading="lazy" alt="Rakuten Viber Official Silver Partner" class="h-24 md:h-32 w-auto drop-shadow-md object-contain" />
           </a>
        </div>
        <h1 class="text-4xl md:text-6xl font-extrabold text-[#3070b6] mb-6 leading-tight">
          {{ $t('intentPages.viberChatbotApi.heroTitle') }}
        </h1>
        <p class="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-10 leading-relaxed">
          {{ $t('intentPages.viberChatbotApi.heroSubtitle') }}
        </p>
        <div class="flex justify-center flex-wrap gap-4">
          <a href="https://docs.mycode.bot/" target="_blank" class="nav-link button filled px-8 py-4 text-lg font-bold rounded-xl shadow-lg hover:shadow-xl transition">
            View API Docs
          </a>
          <NuxtLink to="/register-bot" class="button outlined px-8 py-4 text-lg font-bold rounded-xl shadow-md bg-white">
            Get API Token
          </NuxtLink>
        </div>
      </div>
    </div>

    <!-- Features / Why Choose Us -->
    <div class="page-section py-20 bg-white">
      <div class="container mx-auto max-w-7xl px-4">
        <div class="text-center mb-16">
          <h2 class="text-3xl font-bold text-gray-900">{{ $t('intentPages.viberChatbotApi.whyTitle') }}</h2>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div class="feature-card p-8 rounded-2xl bg-slate-50 border border-slate-100 text-center hover:-translate-y-2 transition duration-300">
            <i class="pi pi-code text-5xl text-[#3070b6] mb-6"></i>
            <h3 class="text-xl font-bold mb-4">{{ $t('intentPages.viberChatbotApi.whyItems[0].title') }}</h3>
            <p class="text-gray-600 leading-relaxed">
              {{ $t('intentPages.viberChatbotApi.whyItems[0].description') }}
            </p>
          </div>
          <div class="feature-card p-8 rounded-2xl bg-slate-50 border border-slate-100 text-center hover:-translate-y-2 transition duration-300">
            <i class="pi pi-server text-5xl text-[#3070b6] mb-6"></i>
            <h3 class="text-xl font-bold mb-4">{{ $t('intentPages.viberChatbotApi.whyItems[1].title') }}</h3>
            <p class="text-gray-600 leading-relaxed">
              {{ $t('intentPages.viberChatbotApi.whyItems[1].description') }}
            </p>
          </div>
          <div class="feature-card p-8 rounded-2xl bg-slate-50 border border-slate-100 text-center hover:-translate-y-2 transition duration-300">
            <i class="pi pi-image text-5xl text-[#3070b6] mb-6"></i>
            <h3 class="text-xl font-bold mb-4">{{ $t('intentPages.viberChatbotApi.whyItems[2].title') }}</h3>
            <p class="text-gray-600 leading-relaxed">
              {{ $t('intentPages.viberChatbotApi.whyItems[2].description') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Section for AI Context -->
    <div class="page-section py-20 bg-gray-50 border-t border-gray-100">
      <div class="container mx-auto max-w-4xl px-4">
        <PopularQuestions :title="$t('intentPages.viberChatbotApi.faqTitle')" :questions="faqItems" />
      </div>
    </div>
    
  </div>
</template>

<style scoped lang="scss">
.provider-intent-page {
  .button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
